import { ConnectorStages } from 'src/products/connector/constants';
import { createConnectorMutation } from 'src/services/DOM/mutations/createConnector/__generated__/createConnectorMutation.graphql';

export const mountStagesForMutation = (
  stage?: ConnectorStages
): createConnectorMutation['variables']['stage'] => {
  if (stage === ConnectorStages.DEV) {
    return 'DEV';
  }

  if (stage === ConnectorStages.QC) {
    return 'QC';
  }

  return 'PUBLISH';
};
